export enum SearchType {
  DIRECT = 'DIRECT',
  RECENT = 'RECENT',
  RECOMMEND = 'RECOMMEND',
  POPULAR = 'POPULAR',
  AUTO_COMPLETE_SEARCH_KEYWORD = 'AUTO_COMPLETE_SEARCH_KEYWORD',
  AUTO_COMPLETE_CATEGORY = 'AUTO_COMPLETE_CATEGORY',
  AUTO_COMPLETE_BRAND = 'AUTO_COMPLETE_BRAND',
  AUTO_COMPLETE_MARKET = 'AUTO_COMPLETE_MARKET',
  AUTO_COMPLETE_EVENT = 'AUTO_COMPLETE_EVENT',
  AUTO_COMPLETE_LICENSED_IP = 'AUTO_COMPLETE_LICENSED_IP',
  AUTO_COMPLETE_OFFICIAL_MARKET = 'AUTO_COMPLETE_OFFICIAL_MARKET',
  AUTO_COMPLETE_SERVICE = 'AUTO_COMPLETE_SERVICE',
  AUTO_COMPLETE_DEEPLINK = 'AUTO_COMPLETE_DEEPLINK',
  ASSOCIATED = 'ASSOCIATED',
  ASSOCIATED_INLINE = 'ASSOCIATED_INLINE',
  ETC = 'ETC',
  POPULAR_HOME = 'POPULAR_HOME',
  SPELL_ORIGINAL = 'SPELL_ORIGINAL',
  SPELL_SUGGESTION = 'SPELL_SUGGESTION',
  POPULAR_WIDGET = 'POPULAR_WIDGET',
  BEAUTY_RECOMMEND = 'BEAUTY_RECOMMEND',
  CATEGORY_KEYWORD = 'CATEGORY_KEYWORD',
  POPULAR_CATEGORY = 'POPULAR_CATEGORY',
}

export const SearchTypeLiteral: Record<SearchType, string> = {
  [SearchType.DIRECT]: '직접입력',
  [SearchType.RECENT]: '최근검색어',
  [SearchType.RECOMMEND]: '추천검색어',
  [SearchType.POPULAR]: '인기검색어',
  [SearchType.AUTO_COMPLETE_SEARCH_KEYWORD]: '자동완성_검색어',
  [SearchType.AUTO_COMPLETE_CATEGORY]: '자동완성_카테고리',
  [SearchType.AUTO_COMPLETE_BRAND]: '자동완성_브랜드',
  [SearchType.AUTO_COMPLETE_MARKET]: '자동완성_마켓',
  [SearchType.AUTO_COMPLETE_EVENT]: '자동완성_이벤트',
  [SearchType.AUTO_COMPLETE_LICENSED_IP]: '자동완성_IP홈',
  [SearchType.AUTO_COMPLETE_OFFICIAL_MARKET]: '자동완성_공식마켓',
  [SearchType.AUTO_COMPLETE_SERVICE]: '자동완성_서비스',
  [SearchType.AUTO_COMPLETE_DEEPLINK]: '자동완성_딥링크',
  [SearchType.ASSOCIATED]: '연관검색어',
  [SearchType.ASSOCIATED_INLINE]: '연관검색어_검색결과내',
  [SearchType.ETC]: '기타',
  [SearchType.POPULAR_HOME]: '인기검색어_홈탭',
  [SearchType.SPELL_ORIGINAL]: '오타교정_원질의어',
  [SearchType.SPELL_SUGGESTION]: '오타교정_제안검색',
  [SearchType.POPULAR_WIDGET]: '인기검색어_위젯',
  [SearchType.BEAUTY_RECOMMEND]: '뷰티_추천검색어',
  [SearchType.CATEGORY_KEYWORD]: '카테고리키워드',
  [SearchType.POPULAR_CATEGORY]: '인기_카테고리_검색어',
};
